module.exports = __webpack_public_path__ + "media/images/persona-login-b5ca2fa271b121c2ec39cbe2014ef0de.png";